import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncScanMethod({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/scanMethod"));
  console.log("Loading", AsyncScanMethod.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncScanMethod;
